import type { WebStorage } from 'redux-persist';
import createWebStorage from 'redux-persist/lib/storage';

let storage: WebStorage;

if (typeof window !== 'undefined') {
  // Use localStorage in the browser
  storage = createWebStorage;
} else {
  // Noop storage for SSR (returns valid WebStorage shape)
  storage = {
    getItem: async (_key: string): Promise<string | null> => null,
    setItem: async (_key: string, _value: string): Promise<void> => {},
    removeItem: async (_key: string): Promise<void> => {},
  };
}

export default storage;
